import { LoginResponse } from "@scrile/api-provider/dist/api/LoginProvider";
import AppStorage from "./appStorage";

const LOGIN_DATA = "LOGIN_DATA";

export type LoginData = Pick<LoginResponse, "user" | "authorities">;

export function setLoginData({ user, authorities }: LoginData) {
  AppStorage.setString(LOGIN_DATA, JSON.stringify({ user, authorities }));
}

export function getLoginData(): LoginData | null {
  let data = AppStorage.getString(LOGIN_DATA, "");
  return data ? JSON.parse(data) : null;
}

export function removeLoginData() {
  AppStorage.remove(LOGIN_DATA);
}
